import React from 'react';

import ConversationStarters from './conversation_starters';
import MessageList from './message_list';
import LoadingSpinner from 'components/ui/loading_spinner';

import type { ActionVerdict, AssistantAction, Message } from './types';

interface Props {
  messages: Message[];
  resolveDisabled: boolean;
  resuming: boolean;
  showAdminDetails: boolean;
  speaking: boolean;
  onResolveAction: (action: AssistantAction, verdict: ActionVerdict) => void;
  onSelectStarter: (prompt: string) => void;
  onStopSpeaking: () => void;
}

export default function ConversationBody({
  messages,
  resolveDisabled,
  resuming,
  showAdminDetails,
  speaking,
  onResolveAction,
  onSelectStarter,
  onStopSpeaking,
}: Props) {
  if (resuming && messages.length === 0) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <ConversationStarters onSelect={onSelectStarter} />
      <MessageList
        messages={messages}
        resolveDisabled={resolveDisabled}
        showAdminDetails={showAdminDetails}
        speaking={speaking}
        onResolveAction={onResolveAction}
        onStopSpeaking={onStopSpeaking}
      />
    </>
  );
}
